import {IntegrationNs} from "@shared/types";

export const IntegrationTypesConstants: any = {
    JIRA: {
        type: 'JIRA',
        title: 'Jira Cloud',
        subtitle: 'Project Management',
        content: 'Import Issues from Jira projects, including Epics, Tasks, and Subtasks.',
        icon: 'integrations/jira.svg',
        domain: 'atlassian.net',
        badge: 'Two-way sync',
        detailPath: '/settings/integrations/jira',
    } as IntegrationNs.IntegrationType,

    FIGMA: {
        type: 'FIGMA',
        // The company writes it Figma. FIGMA is the enum shouting, not a brand name.
        title: 'Figma',
        subtitle: 'User Interface',
        content: 'Import UI designs from Figma<br/> to save time.',
        icon: 'integrations/figma.svg',
        domain: 'figma.com',
        badge: 'Import',
    } as IntegrationNs.IntegrationType,

    CLAUDE: {
        type: 'CLAUDE',
        title: 'Claude',
        subtitle: 'AI Code Completion',
        content: 'Suggests code and functions in the IDE using AI trained on public code and documentation.',
        icon: 'integrations/claude.svg',
        domain: 'claude.ai',
    } as IntegrationNs.IntegrationType,

    CURSOR: {
        type: 'CURSOR',
        title: 'Cursor',
        subtitle: 'AI Code Assistant',
        content: 'Generates, edits, and debugs code in the IDE using an AI-powered assistant.',
        icon: 'integrations/cursor.svg',
        domain: 'cursor.com',
    } as IntegrationNs.IntegrationType,

    GITHUBCOPILOT: {
        type: 'GITHUBCOPILOT',
        title: 'GitHub Copilot',
        subtitle: 'AI Code Completion',
        content: 'Suggests code and entire functions in the IDE using AI trained on billions of lines of code.',
        icon: 'integrations/github-copilot.svg',
        domain: 'github.com',
    } as IntegrationNs.IntegrationType,

    TRELLO: {
        type: 'TRELLO',
        title: 'Trello',
        subtitle: 'Project Management',
        content: 'Push features ready for development into Jira as stories or epics.',
        icon: 'integrations/trello.svg',
    } as IntegrationNs.IntegrationType,

    PIVOTAL: {
        type: 'PIVOTAL',
        title: 'Pivotal Tracker',
        subtitle: 'Project Management',
        content: 'Push features ready for development into Jira as stories or epics.',
        icon: 'integrations/pivotal-tracker.svg',
    } as IntegrationNs.IntegrationType,

    SLACK: {
        type: 'SLACK',
        title: 'Slack',
        subtitle: 'Communication',
        content: 'Push features ready for development into Jira as stories or epics.',
        icon: 'integrations/slack.svg',
    } as IntegrationNs.IntegrationType,

    AZURE: {
        type: 'AZURE',
        title: 'Azure Boards',
        subtitle: 'Project Management',
        content: 'Import work items from Azure Boards, including Epics, User Stories, and Tasks.',
        icon: 'integrations/azure.svg',
        domain: 'dev.azure.com',
        badge: 'Two-way sync',
        detailPath: '/settings/integrations/azure-boards',
    } as IntegrationNs.IntegrationType,

    GOOGLE_DRIVE: {
        type: 'GOOGLE_DRIVE',
        title: 'Google Drive',
        subtitle: 'Cloud Storage',
        content: 'Connect Google Drive to attach and share files directly within your workspace.',
        icon: 'integrations/google-drive.svg',
        domain: 'drive.google.com',
        badge: 'Import',
    } as IntegrationNs.IntegrationType,
};


